import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './MobileFilterDrawer.css';

const MobileFilterDrawer = ({ isOpen, onClose, onApply, onClear, filterControls, isAnyFilterActive }) => {
  const drawerRef = useRef();
  const { t } = useTranslation();

  // Close drawer if click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="mobile-drawer-overlay" role="dialog" aria-modal="true">
      <div className="mobile-drawer" ref={drawerRef}>
        <div className="drawer-header">
          <h2>{t('mobileFilterDrawer.filters')}</h2>
          <button type="button" className="drawer-close-button" onClick={onClose} aria-label={t('mobileFilterDrawer.closeFilters')}>
            &times;
          </button>
        </div>

        <div className="drawer-content">{filterControls}</div>

        <div className="drawer-actions">
          {isAnyFilterActive && (
            <button type="button" className="drawer-clear-button" onClick={onClear}>
              {t('mobileFilterDrawer.clearAll')}
            </button>
          )}
          <button type="button" className="drawer-apply-button" onClick={onApply}>
            {t('mobileFilterDrawer.done')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileFilterDrawer;
